'use client';

import { useEffect } from 'react';

const BOOTSTRAP_SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

/** Loads the Trustpilot bootstrap only when a TrustBox is about to scroll into view. */
export function TrustpilotScript() {
  useEffect(() => {
    const widgets = document.querySelectorAll('.trustpilot-widget');
    if (widgets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        if (document.querySelector(`script[src="${BOOTSTRAP_SRC}"]`)) return;
        const s = document.createElement('script');
        s.src = BOOTSTRAP_SRC;
        s.async = true;
        document.body.appendChild(s);
      },
      { rootMargin: '300px' }
    );
    widgets.forEach((widget) => observer.observe(widget));
    return () => observer.disconnect();
  }, []);

  return null;
}
